import { LoaderFunctionArgs } from "react-router-dom";
import {
  Form,
  Link,
  Outlet,
  RouterProvider,
  createBrowserRouter,
  redirect,
  useActionData,
  useFetcher,
  useLocation,
  useNavigation,
  useRouteLoaderData,
} from "react-router-dom";
import { isAuthenticated, logout } from "./services/auth";
import Login from "./pages/Login/Login";
import Register from "./pages/Register/Register";
import Home from "./pages/UserHome/Home";
import Clients from "./pages/Clients/Clients";
import AuthContext from "./context/AuthProvider";
import { useContext, useEffect, useRef} from 'react';
import Client from "./pages/Client/Client";
import Modal from "./pages/ComponentTester/Modal";
import Forgot from "./pages/Forgot/Forgot";

function Layout() {
    return (
      <div>
        <h1>Auth Example using RouterProvider</h1>
  
        <p>
          This example demonstrates a simple login flow with three pages: a public
          page, a protected page, and a login page. In order to see the protected
          page, you must first login. Pretty standard stuff.
        </p>
  
        <p>
          First, visit the public page. Then, visit the protected page. You're not
          yet logged in, so you are redirected to the login page. After you login,
          you are redirected back to the protected page.
        </p>
  
        <p>
          Notice the URL change each time. If you click the back button at this
          point, would you expect to go back to the login page? No! You're already
          logged in. Try it out, and you'll see you go back to the page you
          visited just *before* logging in, the public page.
        </p>
  
  
        <ul>
          <li>
            <Link to="/login">Public Page</Link>
          </li>
          <li>
            <Link to="/home">Protected Page</Link>
          </li>
        </ul>
  
        <Outlet />
      </div>
    );
  }

function LogoutRender(){
  logout()
  return redirect("/")
}

const router = createBrowserRouter([
  {
    id: "root",
    path: "/",
    children: [
      {
        index: true,
        loader: publicRender,
        Component: Login,
      },
      {
        path: "login",
        loader: publicRender,
        Component: Login,
      },
      {
        path: "register",
        loader: publicRender,
        Component: Register,
      },
      {
        path: "forgot",
        loader: publicRender,
        Component: Forgot,
      },
      {
        path: "home",
        loader: protectedLoader,
        Component: Home,
      },
      {
        path: "logout",
        loader: LogoutRender,
        Component: Home
      }
    ],
  },
  {
    id: "clients",
    path: "clients",
    children: [
      {
        index: true,
        loader: protectedLoader,
        Component: Clients
      },
      {
        path: ":client",
        loader: protectedLoader,
        Component: Client
      }
    ]
  },
  {
    id: "tester",
    path: "tester",
    children: [
      {
        index: true,
        loader: publicRender,
        Component: Modal
      },
    ]
  }
]);

export default function App() {
  // const {auth, setAuth } = useContext(AuthContext);

  // const isInitialMount = useRef(0);

  // useEffect(() => {
  //   console.log("b")
  //   if (isInitialMount.current < 2) {
  //     isInitialMount.current += 1;
  //   } else {
  //     window.location.reload();
  //   }
  // }, [auth]);

  return (
    <RouterProvider router={router} fallbackElement={<p>Initial Load...</p>} />
  );
}

function protectedLoader({ request }) {
  // If the user is not logged in and tries to access `/protected`, we redirect
  // them to `/login` with a `from` parameter that allows login to redirect back
  // to this page upon successful authentication
  if (!isAuthenticated()) {
    let params = new URLSearchParams();
    params.set("from", new URL(request.url).pathname);
    return redirect("/login?" + params.toString());
  }
  return null;
}

async function publicRender() {
    if (isAuthenticated()) {
      return redirect("/home");
    }
    return null;
  }